import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import {
  AllCheckState,
  TermsAgreeState,
  RecoilStateList,
  uiTermsStyle,
} from 'src/recoil/common'
import React, { useEffect } from 'react'
import * as S from 'src/styles/styledcomponent/views/mkt03/Terms'
import checkbox from 'src/assets/images/mkt03/checkbox.svg'
import nonCheckbox from 'src/assets/images/mkt03/nonCheckbox.svg'
import check from 'src/assets/images/mkt03/check.svg'
import nonCheck from 'src/assets/images/mkt03/nonCheck.svg'
import { JoinTermsDetail } from 'src/types/type'
import { monitoredOpen } from 'src/service/utils/sentry/navigation'

const Terms = (props: any): JSX.Element => {
  const { data } = props
  const params = useParams()
  const { TelType, AllTermsAgree, termsAgree, TermsData, isAgreeAllRequiredTerms } = useRecoilValue(RecoilStateList)
  const setAllTermsAgree = useSetRecoilState(AllCheckState)
  const setTermsAgree = useSetRecoilState(TermsAgreeState)
  const ResetJoinTerms = useResetRecoilState(TermsAgreeState)
  const { borderRadius, actColor } = useRecoilValue(uiTermsStyle)
  const termsOpen = (order: number): void => {
    // 약관 보기
    const width: number = 400
    const height: number = 600
    const url: string | undefined = params?.requestID
      ? `/terms/${params.requestID}/${TelType}/${TermsData.TermsIdx}/${order}`
      : undefined

    if (url) {
      monitoredOpen(url, 'termsOpen', '_blank', {
        windowFeatures: `width=${width}, height=${height}`,
      })
    }
  }
  const AllTerms = (): void => {
    // 전체동의
    const arrCopy = [...termsAgree]
    if (!AllTermsAgree) {
      TermsData?.Terms
        .forEach((terms: JoinTermsDetail) => {
          if (terms.Order !== undefined && terms.Required === 1) {
            arrCopy[terms.Order - 1] = 1
          }
        })
    } else {
      arrCopy.fill(0)
    }
    setTermsAgree(arrCopy)
    setAllTermsAgree((AllTermsAgree) => !AllTermsAgree)
  }
  const EachTerms = (order: number): void => {
    // 개별동의
    const arrCopy = [...termsAgree]
    arrCopy[order - 1] = Math.abs(termsAgree[order - 1] - 1)
    setTermsAgree(arrCopy)
  }

  useEffect(() => {
    ResetJoinTerms()
    setAllTermsAgree(false)
  }, [ResetJoinTerms, TelType, data, setAllTermsAgree])

  useEffect(() => {
    setAllTermsAgree(isAgreeAllRequiredTerms)
  }, [isAgreeAllRequiredTerms, setAllTermsAgree])

  return (
    <S.TermsAgreeWrap borderRadius={borderRadius}>
      <S.AllTermsContainer
        checkColor={actColor}
        onClick={AllTerms}
        active={AllTermsAgree}
      >
        {AllTermsAgree ? <img src={checkbox} alt="체크" /> : <img src={nonCheckbox} alt="비체크" />}
        <p>필수 약관 전체 동의</p>
      </S.AllTermsContainer>
      <S.EachTermsContainer>
        {TermsData?.Terms.map((terms: JoinTermsDetail, index: number) => (
          <S.EachTermsItems key={index} onClick={() => terms.Order !== undefined && EachTerms(terms.Order)}>
            {terms.Order !== undefined && termsAgree[terms.Order - 1] === 1 ? (
              <img src={check} alt="체크" />
            ) : (
              <img src={nonCheck} alt="비체크" />
            )}
            <p
              onClick={() => terms.Order !== undefined && termsOpen(terms.Order)}
            >
              {terms.Title}
              {terms.Required === 1 ? '' : '(선택)'}
            </p>
          </S.EachTermsItems>
        ))}
      </S.EachTermsContainer>
    </S.TermsAgreeWrap>
  )
}
export default Terms
